import { categories } from "@/mocks/site";
import type { TopicStatus, Verdict } from "@/types/news";

export function getCategoryName(slug: string): string {
  return categories.find((item) => item.slug === slug)?.name ?? "热议追踪";
}

export function formatHeat(value: number): string {
  if (value >= 10000) return `${(value / 10000).toFixed(1)} 万`;
  return `${value}`;
}

interface MetaStyle {
  label: string;
  className: string;
  icon: string;
}

export function statusMeta(status: TopicStatus): MetaStyle {
  switch (status) {
    case "settled":
      return {
        label: "已核实",
        className: "bg-secondary-100 text-secondary-800 border-secondary-300",
        icon: "ri-checkbox-circle-line",
      };
    case "verifying":
      return {
        label: "核查中",
        className: "bg-accent-100 text-accent-800 border-accent-300",
        icon: "ri-search-eye-line",
      };
    default:
      return {
        label: "追踪中",
        className: "bg-primary-100 text-primary-800 border-primary-300",
        icon: "ri-pulse-line",
      };
  }
}

export function verdictMeta(verdict: Verdict): MetaStyle {
  switch (verdict) {
    case "true":
      return { label: "属实", className: "bg-secondary-100 text-secondary-800", icon: "ri-check-line" };
    case "false":
      return { label: "不实", className: "bg-primary-100 text-primary-800", icon: "ri-close-line" };
    case "partial":
      return { label: "部分属实", className: "bg-accent-100 text-accent-800", icon: "ri-subtract-line" };
    default:
      return { label: "暂无定论", className: "bg-background-200 text-foreground-700", icon: "ri-question-line" };
  }
}